import * as React from 'react';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
  palette: {
    primary: { main: "#209CEE" }, // Blue color
    secondary: { main: '#1ce684' } // Green color
  },
  typography: {
    fontFamily: '"Montserrat", sans-serif',
    display1: {
      fontSize: '25px',
      fontWeight: 700,
      lineHeight: '33px',
      color: '#454545'
    },
    display2: {
      fontSize: '21px',
      fontWeight: 600,
      lineHeight: '33px',
      color: '#fff'
    },
    title: {
      fontSize: '16px',
      fontWeight: 600,
      lineHeight: '20px',
      color: '#454545'
    },
    body1: {
      fontSize: '12px',
      fontWeight: 400,
      lineHeight: '20px',
      color: '#454545'
    },
    body2: {
      fontSize: '16px',
      fontWeight: 500,
      lineHeight: '23px',
      color: '#454545'
    },
    subheading:{
      fontSize: '24px',
      fontWeight: 400,
      lineHeight: '26px',
      color: '#454545'
    }
  },
  overrides: {
    MuiButton: {
      'raisedPrimary': {
        color: '#FFFFFF',
      },
      'raisedSecondary': {
        color: '#FFFFFF',
      },
    },
  }
});

function ThemeProvider(props) {
  return (
    <MuiThemeProvider theme={theme}>
      {props.children}
    </MuiThemeProvider>
  );
}

export default ThemeProvider;
